// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Dashboard_dashboard__3goIn","container":"Dashboard_container__3626o","col-padding":"Dashboard_col-padding__1qVUP","box-container":"Dashboard_box-container__2ajSp"};